// Çalışan rolü / eğitim grubu değerleri için tek kaynak.
//
// Employees.role alanı; SOP, Form ve İndikasyon Eğitimi atamalarındaki "group"
// alanıyla AYNI değerleri kullanmak zorundadır — ProfilePage bu eşleşme ile
// içerik çeker (where('group', 'array-contains', userData.role)). Bu yüzden
// listeye ekleme/çıkarma yaparken mevcut kayıtların etkileneceğini unutmayın.
export const EMPLOYEE_GROUP_OPTIONS = [
  'Hepsi',
  'Saha Koordinatörü',
  'Klinik Araştırma Hemşiresi',
  'Proje Müdürü',
  'Çalışma Başlatma Sorumlusu',
  'Backup Personeli',
  'CRA',
  'Kalite Müdürü',
  'Finans Uzmanı',
  'IT Uzmanı',
  'IK Uzmanı',
  'İş Geliştirme Uzmanı',
  'Eğitim Sorumlusu'
];

// "Hepsi" bir çalışan rolü değil, içerik atamalarında "tüm roller" anlamına
// gelen özel bir gruptur; rol seçiminde gösterilmez.
export const EMPLOYEE_ROLE_OPTIONS = EMPLOYEE_GROUP_OPTIONS.filter(
  (g) => g !== 'Hepsi'
);
